<template>
	<o-section :title="$t('business.logoCompany.modifyTitle')">
		<o-upload
			v-model="setup.files"
			:file-types="['image/jpeg', 'image/png']"
			:label="$t('common.order.creation.step1.toolbox.taskTemplate.dragDropLogoFile')">
			<o-cropper
				v-if="setup.selectedFile"
				:ref="setup._cropper"
				:file="setup.selectedFile"
				:crop-width="200"
				:crop-height="200"/>
		</o-upload>
	</o-section>

	<o-section align="stretch">
		<o-button
			color="danger"
			outline
			@click="_modal?.close()">
			{{ $t('common.actions.cancel') }}
		</o-button>
		<o-pop-confirm @confirm="setup.deleteAsync()">
			<o-button
				v-if="companyLogoId"
				color="danger">
				{{ $t('common.shared.actions.delete') }}
			</o-button>
		</o-pop-confirm>
		<o-button
			color="info"
			@click="setup.uploadAsync()">
			{{ $t('common.actions.validate') }}
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedLogoCompanyModalEmits, SharedLogoCompanyModalProps } from './SharedLogoCompanyModalSetup';
import SharedLogoCompanyModalSetup from './SharedLogoCompanyModalSetup';
const emits = defineEmits<SharedLogoCompanyModalEmits>() as SharedLogoCompanyModalEmits;
const props = withDefaults(defineProps<SharedLogoCompanyModalProps>(), SharedLogoCompanyModalSetup.defaultProps);
// #endregion
import { inject } from 'vue';

const _modal = inject<OrionModal>('_modal');
const setup = new SharedLogoCompanyModalSetup(props, emits, _modal);
</script>
